module.exports = __webpack_public_path__ + "media/src/img/payment/phone-3f93e108ac18c13c8861a2b552e32d09.svg";